export const PUBLIC_MEANS_OF_TRANSPORT = [
    {value: 'TRAIN', label: 'Bahn & S-Bahn', trackingLabel: 'Train', trackingValue: 'train', urlSlug: 'Bahn'},
    {value: 'UNDERGROUND_RAILWAY', label: 'U-Bahn', trackingLabel: 'Underground Railway', trackingValue: 'underground_railway'},
    {value: 'TRAM', label: 'Straßenbahn', trackingLabel: 'Tram', trackingValue: 'tram'},
    {value: 'CITY_BUS', label: 'Stadtbus', trackingLabel: 'City Bus', trackingValue: 'city_bus'},
    {value: 'REGIONAL_BUS', label: 'Regionalbus', trackingLabel: 'Regional Bus', trackingValue: 'regional_bus'},
    {value: 'EXPRESS_BUS', label: 'Fernbus', trackingLabel: 'Express Bus', trackingValue: 'express_bus'},
    {value: 'SHIP', label: 'Schiff', trackingLabel: 'Ship', trackingValue: 'ship'},
    {value: 'CABLE_COG_RAILWAY', label: 'Seil-/Zahnradbahn', trackingLabel: 'Cable Cog Railway', trackingValue: 'cable_cog_railway'},
    {value: 'CALL_PICKUP_TAXI_BUS', label: 'Anrufsammeltaxi', trackingLabel: 'Call pickup Taxi Bus', trackingValue: 'call_pickup_taxi_bus'},
    {value: 'OTHER', label: 'Sonstige', trackingLabel: 'Other', trackingValue: 'other'}
]

export const PUBLIC_MEANS_OF_TRANSPORT_SUB = [
    {value: 'URBAN_RAILWAY', label: 'URBAN_RAILWAY'},
    {value: 'CITY_RAILWAY', label: 'CITY_RAILWAY'},
    {value: 'CAR_TRAIN', label: 'Autoreisezug'},
]

export const PUBLIC_MEANS_OF_TRANSPORT_FULL = [
    ...PUBLIC_MEANS_OF_TRANSPORT,
    ... PUBLIC_MEANS_OF_TRANSPORT_SUB
]